module.exports = __webpack_public_path__ + "assets/images/81140cc39e23fe6a0ee4f60cde2cc08c.png";